// Influence's registration (docs/features/purchases.md): the window `influence` and Home's Influence item.
import { registerWindow } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'

registerWindow('influence', { module: () => import('./influence.js'), css: 'windows/influence/influence.css', title: () => 'Influence', place: ['home', 'above'] })
registerHomeItem({ id: 'influence', label: 'Influence', symbol: 'chart.bar.doc.horizontal', needs: '', section: 'toolbar', order: 90 })
